import React, { useContext, useEffect, useMemo, useState } from 'react';

import { PacksContext, PacksDispatchContext } from './ApiProvider';
import AmountForm from './popupForms/AmountForm';
import EditContractorPackToVenueForm from './popupForms/EditContractorPackToVenueForm';
import PackCategoryForm from './popupForms/PackCategoryForm';
import PackForm from './popupForms/PackForm';
import PackItemForm from './popupForms/PackItemForm';
import PackToVenueForm from './popupForms/PackToVenueForm';

import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

import useModal from 'Hooks/useModal';

const components = {
    createSimpleItem: PackItemForm,
    createContractorItem: PackItemForm,
    createSimplePack: PackForm,
    createContractorPack: PackForm,
    createSimpleCategory: PackCategoryForm,
    createContractorCategory: PackCategoryForm,
    itemToPack: AmountForm,
    packToVenue: PackToVenueForm,
    editPackToVenue: EditContractorPackToVenueForm,
};

function Popup({ budgetTagsUrl }) {
    const [venue, setVenue] = useState();
    const [pack, setPack] = useState();
    const [packItem, setPackItem] = useState();

    const { popup, venues, packs, packItems } = useContext(PacksContext);
    const apiCall = useContext(PacksDispatchContext);

    useEffect(() => {
        if (['createSimplePack', 'createContractorPack'].includes(popup?.type) && popup?.id) {
            setPack(packs.find((pack) => pack.id == popup.id));
        } else if (['createSimpleItem', 'createContractorItem'].includes(popup?.type) && popup?.id) {
            setPackItem(packItems.find((item) => item.id == popup.id));
        } else if (['createSimpleCategory', 'createContractorCategory'].includes(popup?.type)) {
            // Category form needs no extra state
        } else if (popup?.type === 'itemToPack' && popup.itemId && popup.packId) {
            setPack(packs.find((pack) => pack.id == popup.packId));
            setPackItem(packItems.find((item) => item.id == popup.itemId));
        } else if (popup?.type === 'packToVenue' && popup.venueId && popup.packId) {
            setPack(packs.find((pack) => pack.id == popup.packId));
            setVenue(venues.find((venue) => venue.id == popup.venueId));
        } else if (popup?.type === 'editPackToVenue' && popup.venueId && popup.packId) {
            setPack(packs.find((pack) => pack.id == popup.packId));
            setVenue(venues.find((venue) => venue.id == popup.venueId));
        }
    }, [venues, packs, packItems, popup]);

    const title = useMemo(() => {
        switch (popup?.type) {
            case 'createSimpleItem':
                return popup.id ? $t('Edit Simple Pack Item') : $t('Create Simple Pack Item');
            case 'createContractorItem':
                return popup.id ? $t('Edit Contractor Pack Item') : $t('Create Contractor Pack Item');
            case 'createSimplePack':
                return popup.id ? $t('Edit Simple Pack') : $t('Create Simple Pack');
            case 'createContractorPack':
                return popup.id ? $t('Edit Contractor Pack') : $t('Create Contractor Pack');
            case 'createSimpleCategory':
                return popup.id ? $t('Edit Category') : $t('Add Category');
            case 'createContractorCategory':
                return popup.id ? $t('Edit Category') : $t('Add Category');
            case 'itemToPack':
                return $t('Add {{pack_item_name}} to {{pack_name}}', { pack_item_name: packItem?.name, pack_name: pack?.name });
            case 'packToVenue':
                return popup.formattedDates.length > 1
                    ? $t('Assign {{pack_name}} to {{venue_name}} on {{days}} days from {{from_date}} to {{to_date}}', {
                          pack_name: pack?.name,
                          venue_name: venue?.name,
                          days: popup.formattedDates.length,
                          from_date: popup.formattedDates[0],
                          to_date: popup.formattedDates.slice(-1),
                      })
                    : $t('Assign {{pack_name}} to {{venue_name}} on {{date}}', {
                          pack_name: pack?.name,
                          venue_name: venue?.name,
                          date: popup.formattedDates.length === 1 ? popup.formattedDates[0] : popup.formattedDate,
                      });
            case 'editPackToVenue':
                return popup.formattedDates?.length > 1
                    ? $t('Edit {{pack_name}} at {{venue_name}} on {{days}} days from {{from_date}} to {{to_date}}', {
                          pack_name: pack?.name,
                          venue_name: venue?.name,
                          days: popup.formattedDates.length,
                          from_date: popup.formattedDates[0],
                          to_date: popup.formattedDates.slice(-1),
                      })
                    : $t('Edit {{pack_name}} at {{venue_name}} on {{date}}', {
                          pack_name: pack?.name,
                          venue_name: venue?.name,
                          date: popup.formattedDates?.length === 1 ? popup.formattedDates[0] : popup.formattedDate,
                      });
        }
    }, [popup, venue, pack, packItem]);

    const modal = useModal();

    const close = () => {
        apiCall('form', false);
        modal.hide();
    };

    useEffect(() => {
        popup && popup.type ? modal.show() : modal.hide();
    }, [popup]);

    const Form = popup ? components[popup.type] : '';

    const isEditContractorPackModal = popup?.type === 'editPackToVenue';

    return (
        <Modal id="PACK_FORMS_MODAL" modal={modal} containerStyle={isEditContractorPackModal ? { maxWidth: '1280px' } : {}}>
            {popup && popup.type && (
                <>
                    <ModalHeader title={title} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        <div
                            className={
                                isEditContractorPackModal ? 'modal__form-container tw-overflow-auto tw-max-h-[min(80vh,800px)]' : 'modal__form-container'
                            }
                        >
                            <Form {...popup} budgetTagsUrl={budgetTagsUrl} />
                        </div>
                    </div>
                </>
            )}
        </Modal>
    );
}

export default Popup;
